import addresses from '1stdibs-contracts/addresses.json';

const AuctionV2Addresses = addresses.FirstDibsAuctionV2;

type AuctionV2AddressType = keyof typeof AuctionV2Addresses;

const auctionV2Addresses = Object.keys(AuctionV2Addresses).map(network =>
    AuctionV2Addresses[network as AuctionV2AddressType].address?.toLowerCase()
);

export const isV2Auction = (auctionContractAddress?: string | null): boolean => {
    if (!auctionContractAddress) {
        return false;
    }
    return auctionV2Addresses.includes(auctionContractAddress?.toLowerCase());
};
